<template>
  <q-card style="min-width: 280px" class="q-pa-md">
    <form-header :header-text="header" />
    <q-card-section v-for="(item, key) in formData" :key="key" class="q-pt-none">
      <div class="row q-gutter-sm q-my-sm" v-if="formData[key]">
        <div class="col" v-if="key === 'carts' || key === 'pedestals'">
          <q-select
            filled
            v-model="option[key === 'carts' ? 'carts' : 'pedestals']"
            use-input
            :options="options[key === 'carts' ? 'carts' : 'pedestals']"
            color="accent"
            :label="formLabel('type')"
            behavior="menu"
          ></q-select>
        </div>
        <div class="col">
          <q-input
            filled
            clearable
            :ref="(getFormRef(index) as any)"
            v-model="formData[key].value"
            :label="formItem(key)"
            :type="item.type"
          />
        </div>
      </div>
    </q-card-section>

    <q-card-actions align="right" class="text-primary">
      <q-btn flat :label="formLabel('close')" v-close-popup />
      <q-btn color="primary" :label="formLabel('save')" @click="save" v-close-popup />
    </q-card-actions>
  </q-card>
</template>
<script lang="ts">
import { QInput } from 'quasar'
import { computed, defineComponent, onBeforeMount, onBeforeUpdate, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStoreProfiles } from '../store/useStoreProfiles'
import FormHeader from './FormHeader.vue'
export default defineComponent({
  components: { FormHeader },
  emits: ['onSave'],
  props: {
    header: {
      required: true,
      type: String,
    },
    data: {
      required: true,
      type: Object,
    },
    storeId: {
      required: true,
      type: Number,
    },
  },
  setup(props) {
    const { t } = useI18n({ useScope: 'global' })
    const formItem = (key: string) => t(`storeItems.${key}`)
    const formLabel = (key: string) => t(`form.${key}`)

    const formRefs = ref<QInput[]>([])
    function getFormRef(index: number) {
      function functionRef(element: QInput) {
        formRefs.value[index] = element
      }
      return functionRef
    }

    const formData = computed(() => {
      if ('liberty_pedestals' in props.data) {
        return {
          // ...(props.data['notes'] && { notes: props.data['notes'].value }),
          // contact_name: props.data['contact_name'].value,
          carts:
            props.data[
              Object.keys(props.data).find(
                (key) => key.includes('cart') && props.data[key].value > 0
              ) || 'small_carts_1sd'
            ],
          pedestals:
            props.data[
              Object.keys(props.data).find(
                (key) => key.includes('pedestal') && props.data[key].value > 0
              ) || 'liberty_pedestals'
            ],
          manned_checkout_number: props.data.manned_checkout_number,
          self_checkout_number: props.data.self_checkout_number,
        }
      } else return props.data
    })

    const options = {
      //TODO sync these from portal?
      carts: [
        { value: 'large_carts_1sd', id: 1, label: formItem('large_carts_1sd') },
        { value: 'large_carts_std', id: 2, label: formItem('large_carts_std') },
        { value: 'small_carts_1sd', id: 3, label: formItem('small_carts_1sd') },
        { value: 'small_carts_std', id: 4, label: formItem('small_carts_std') },
        { value: 'small_carts_thin', id: 5, label: formItem('small_carts_thin') },
      ],
      pedestals: [
        { value: 'liberty_pedestals', id: 1, label: formItem('liberty_pedestals') },
        { value: 'evolve_pedestals', id: 2, label: formItem('evolve_pedestals') },
        { value: 'other_pedestals', id: 3, label: formItem('other_pedestals') },
        { value: 'e10_pedestals', id: 4, label: formItem('e10_pedestals') },
        { value: 'p20_pedestals', id: 5, label: formItem('p20_pedestals') },
        { value: 'noAdPanel_pedestals', id: 6, label: formItem('noAdPanel_pedestals') },
      ],
    }
    const option = ref()

    onBeforeMount(() => {
      //need to set options key to match value key if carts/pedestals are an option
      const cartsIndex =
        options.carts.findIndex(
          (item) => props.data[item.value] && props.data[item.value].value > 0
        ) > -1
          ? options.carts.findIndex((item) => props.data[item.value].value > 0)
          : 0
      const pedestalsIndex =
        options.pedestals.findIndex(
          (item) => props.data[item.value] && props.data[item.value].value > 0
        ) > -1
          ? options.pedestals.findIndex((item) => props.data[item.value].value > 0)
          : 0

      option.value = {
        carts: options.carts[cartsIndex],
        pedestals: options.pedestals[pedestalsIndex],
      }
    })
    onBeforeUpdate(() => {
      formRefs.value = []
      option.value = {}
    })
    const { setStoreEditableItem } = useStoreProfiles()
    const save = () => {
      console.log(formData.value)

      const toSaveData: any = {}
      for (const key in formData.value) {
        if (key == 'carts') {
          toSaveData['cart_size_id'] = String(option.value.carts.id)
          toSaveData['cart_count'] = formData.value.carts.value
        } else if (key == 'pedestals') {
          toSaveData['pedestal_id'] = String(option.value.pedestals.id)
          toSaveData['no_of_pedestals'] = formData.value.pedestals.value
        } else {
          toSaveData[key] = formData.value[key].value
        }
      }
      console.log(toSaveData)
      setStoreEditableItem(toSaveData, { value: props.storeId })
    }
    return {
      formData,
      formItem,
      formLabel,
      getFormRef,
      formRefs,
      option,
      options,
      save,
    }
  },
})
</script>
